import { lazyGettext } from '@eb/lazy-gettext';
import { PACKAGE_ONE, PACKAGE_THREE, PACKAGE_TWO } from '../../constants/main';
import { STYLE_FILL, STYLE_NEUTRAL } from '@eb/eds-button';

export default {
    [PACKAGE_ONE]: {
        packagesList: {
            CTAs: [
                lazyGettext('Your Current Package'),
                lazyGettext('Upgrade'),
                lazyGettext('Contact Us'),
            ],
            CTAStyles: [null, STYLE_FILL, STYLE_NEUTRAL],
        },
        grid: {
            CTAs: [
                lazyGettext('Your Current Package'),
                lazyGettext('Upgrade'),
                lazyGettext('Contact Us'),
            ],
            CTAStyles: [null, STYLE_FILL, STYLE_NEUTRAL],
        },
    },
    [PACKAGE_TWO]: {
        packagesList: {
            CTAs: [
                lazyGettext('Downgrade'),
                lazyGettext('Your Current Package'),
                lazyGettext('Contact Us'),
            ],
            CTAStyles: [STYLE_NEUTRAL, null, STYLE_FILL],
        },
        grid: {
            CTAs: [
                lazyGettext('Downgrade'),
                lazyGettext('Your Current Package'),
                lazyGettext('Contact Us'),
            ],
            CTAStyles: [STYLE_NEUTRAL, null, STYLE_FILL],
        },
    },
    [PACKAGE_THREE]: {
        packagesList: {
            CTAs: [
                lazyGettext('Downgrade'),
                lazyGettext('Downgrade'),
                lazyGettext('Your Current Package'),
            ],
            CTAStyles: [STYLE_NEUTRAL, STYLE_NEUTRAL, null],
        },
        grid: {
            CTAs: [
                lazyGettext('Downgrade'),
                lazyGettext('Downgrade'),
                lazyGettext('Your Current Package'),
            ],
            CTAStyles: [STYLE_NEUTRAL, STYLE_NEUTRAL, null],
        },
    },
};
